export const PROSPECT_SECTORS = [
  'retail',
  'hospitality',
  'industry',
  'logistics',
  'automotive',
  'temp_transport',
  'other',
];

// One list for the add panel and the coming prospect sheet; `field` stays
// readable on existing data but is no longer offered.
export const PROSPECT_SOURCES = [
  'phone',
  'field_visit',
  'referral',
  'search',
  'social',
  'inbound',
];

export const DEFAULT_PROSPECT_SOURCE = 'phone';
